var $kN4w8$react = require("react");
var $kN4w8$truvbridge = require("@truv/bridge");

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $701ea2edfb58594c$export$2e2bcd8739ae039; });


var $701ea2edfb58594c$var$TruvBridge = function(param) {
    var bridgeToken = param.bridgeToken, onSuccess = param.onSuccess, onClose = param.onClose, onEvent = param.onEvent, onLoad = param.onLoad, isOpened = param.isOpened;
    var currentLastInitData = {
        onSuccess: onSuccess,
        onClose: onClose,
        onEvent: onEvent,
        onLoad: onLoad,
        bridgeToken: bridgeToken
    };
    var lastInitData = (0, $kN4w8$react.useRef)(currentLastInitData);
    lastInitData.current = currentLastInitData;
    (0, $kN4w8$react.useEffect)(function() {
        if (!isOpened) return;
        var bridgeInstance = (0, $kN4w8$truvbridge.init)({
            bridgeToken: lastInitData.current.bridgeToken,
            onSuccess: function(publicToken, taskId) {
                lastInitData.current.onSuccess(publicToken, taskId);
            },
            onClose: function() {
                var _lastInitData_current, _lastInitData_current_onClose;
                (_lastInitData_current_onClose = (_lastInitData_current = lastInitData.current).onClose) === null || _lastInitData_current_onClose === void 0 ? void 0 : _lastInitData_current_onClose.call(_lastInitData_current);
            },
            onLoad: function() {
                var _lastInitData_current, _lastInitData_current_onLoad;
                (_lastInitData_current_onLoad = (_lastInitData_current = lastInitData.current).onLoad) === null || _lastInitData_current_onLoad === void 0 ? void 0 : _lastInitData_current_onLoad.call(_lastInitData_current);
            },
            onEvent: function(type, payload) {
                var _lastInitData_current, _lastInitData_current_onEvent;
                (_lastInitData_current_onEvent = (_lastInitData_current = lastInitData.current).onEvent) === null || _lastInitData_current_onEvent === void 0 ? void 0 : _lastInitData_current_onEvent.call(_lastInitData_current, type, payload);
            }
        });
        bridgeInstance.open();
        return function() {
            bridgeInstance.close();
        };
    }, [
        isOpened
    ]);
    return null;
};
var $701ea2edfb58594c$export$2e2bcd8739ae039 = $701ea2edfb58594c$var$TruvBridge;


//# sourceMappingURL=index.js.map
